import React, { useMemo } from "react";
import { Checkbox } from "@mui/material";
import { CustomButton } from "../../../../../common/components";
import styles from "./ProductTourRow.module.css";
import { IS_V2 } from "../constants";

export default function ProductTourRow({ tpt, onSelectRow, checkedPt, onCheck }) {
	const { id, name, companies } = tpt;
	const isChecked = useMemo(() => checkedPt.some((cpt) => cpt.name === tpt.name), [checkedPt, tpt]);
	const handleCheck = () => {
		onCheck(tpt);
	};
	return (
		<div key={id} className={styles.row}>
			<div>
				{IS_V2 && <Checkbox checked={isChecked} onChange={handleCheck} />}
				<span>{name}</span>
			</div>
			<div>
				<CustomButton
					variant="outlined"
					onClick={() => {
						onSelectRow(tpt);
					}}
				>
					{companies || 0}
				</CustomButton>
			</div>
		</div>
	);
}
